import SvgIconBox from '@atoms/SvgIconBox';
import { Pulse } from '@atoms/Pulse';
import { getLiveLayoutColors } from './helper/presentationLive';
import Tooltip from '@atoms/new/tooltip';
import {
  CaretLeftIcon as ArrowBackIosNewRoundedIcon,
  CaretRightIcon as ArrowForwardIosRoundedIcon
} from '@phosphor-icons/react';

const NextPrevCapsule = ({
  linkQuestions,
  currentIndex,
  featurePrevState,
  featureNextState,
  prevRef,
  nextRef,
  isTrack,
  showTotal = true,
  pulseProps = null,
  layoutTheme = 'dark',
  layoutMode,
  isDisabled = false,
  isPreview = false
}) => {
  const colors = getLiveLayoutColors(layoutTheme);
  return (
    <div className={`${isPreview ? 'mr-4' : ''}`}>
      {
        (!isTrack && (currentIndex || currentIndex === 0)) && (
          <div className={`flex relative z-10 ${layoutMode === 'square' && 'scale-80 origin-left'}`}>
            <div
              id="nextPrevCtdId"
              className={`${colors.containerColor} flex items-center justify-center gap-2 rounded-full p-0.5`}>
              <div
                id="prevCtdId"
                ref={prevRef}
                onClick={() => { if (currentIndex > 0 && !isDisabled) featurePrevState(true); }}
                className={`${currentIndex > 0 && !isDisabled ? 'hover:bg-grey-800 cursor-pointer' : ''} flex rounded-full w-12`}
              >
                <Tooltip
                  content="Previous slide"
                  placement="top-start"
                  isDisabled={currentIndex === 0 || isDisabled}
                >
                  <div
                    id='tooltip'
                    className={`${currentIndex > 0 && !isDisabled ? colors.hoverBg : ''} group flex items-center justify-center rounded-full w-12 h-12`}
                  >
                    <ArrowBackIosNewRoundedIcon
                      className={`${linkQuestions.length === 1 || currentIndex === 0 || isDisabled ? 'text-neutral-90 opacity-50 cursor-not-allowed' : colors.svgColor} transition-none!`} size={20}
                    />
                  </div>
                </Tooltip>
              </div>

              {showTotal && <div className='flex items-center'>
                <span className={`z-40 ${colors.textColor} whitespace-nowrap font-medium text-sm leading-3.5 w-5 text-center`}>
                  {currentIndex + 1}</span>
              </div>}

              <div id="nextCtdId"
                ref={nextRef}
                onClick={() => { if (currentIndex + 1 < linkQuestions.length && !isDisabled) featureNextState(true); }}
                className={`${currentIndex + 1 < linkQuestions.length && !isDisabled ? 'hover:bg-grey-800 cursor-pointer' : ''}  flex rounded-full w-12`}
              >
                <Tooltip
                  content="Next slide"
                  placement="top"
                  isDisabled={currentIndex + 1 === linkQuestions.length || isDisabled}
                >
                  <div
                    id='tooltip'
                    className={`${currentIndex + 1 < linkQuestions.length && !isDisabled ? colors.hoverBg : ''} group flex items-center justify-center rounded-full w-12 h-12`}
                  >
                    <ArrowForwardIosRoundedIcon
                      className={`${linkQuestions.length === 1 || currentIndex + 1 === linkQuestions.length || isDisabled ? 'text-neutral-90 opacity-50 cursor-not-allowed' : colors.svgColor} transition-none!`} size={20}
                    />
                  </div>
                </Tooltip>
              </div>
            </div>
            {!!pulseProps && (
              <div className='absolute -top-2 right-2'>
                <Pulse {...pulseProps} />
              </div>
            )}
          </div>
        )
      }
      {
        (isTrack || currentIndex === undefined) && <div id="nextPrevCtdId" className="flex items-center justify-center gap-1 bg-grey-900 rounded-full p-0.5 w-[120px]">

          <div
            id="prevCtdId"
            className='flex items-center w-8'
          >
            <SvgIconBox svg={<ArrowBackIosNewRoundedIcon className='fill-current text-neutral-90' size={20} />} className="w-8 h-8"
              disablePointer={true}
            />
          </div>

          <div className='flex items-center'>
            <span className={'z-50 text-neutral-90 whitespace-nowrap font-medium text-sm leading-3.5 w-5 text-center'}>
              {currentIndex + 1}
            </span>
          </div>

          <div
            className='flex items-center w-8'
          >
            <SvgIconBox svg={<ArrowForwardIosRoundedIcon className='fill-current text-neutral-90' size={20} />} className="w-8 h-8"
              disablePointer={true}
            />
          </div>
        </div>

      }
    </div>
  );
};

export default NextPrevCapsule;
